import { userAgentIsAndroid, userAgentIsIOS, userAgentIsMobile, getBrowser } from './device';

const DEVICE_ID_KEY = 'reclaim_device_id';

export const getDeviceId = (): string => {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (!deviceId) {
        deviceId = crypto.randomUUID();
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
};

export const getDeviceType = (): string => {
    const browser = getBrowser();
    if (userAgentIsAndroid) {
        return `Android ${browser}`;
    }
    if (userAgentIsIOS) {
        return `iOS ${browser}`;
    }
    if (userAgentIsMobile) {
        return `Mobile ${browser}`;
    }
    return `Desktop ${browser}`;
};

export const getPublicIp = async (): Promise<string> => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        if (response.ok) {
            const data = await response.json();
            return data.ip;
        }
    } catch (error) {
        console.error('Error fetching public IP:', error);
    }
    return '';
};

export const updateSession = async (sessionId: string, status: string, metadata?: Record<string, unknown>) => {
    try {
        const deviceId = getDeviceId();
        const deviceType = getDeviceType();
        const publicIpAddress = await getPublicIp();

        const body: Record<string, unknown> = {
            sessionId,
            status,
            deviceId,
            deviceType,
            publicIpAddress,
        };

        if (metadata && Object.keys(metadata).length > 0) {
            body.metadata = metadata;
        }

        const response = await fetch(
            `https://api.reclaimprotocol.org/api/sdk/update/session/`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
            }
        );

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            console.error("Request to update Session Status failed with status:", response.status);
        }
    } catch (error) {
        console.error("Error:", error);
    }
    return undefined;
};
